import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import WorkflowTradeList from "src/components/Refatoracao/TradeList/WorkflowTradeList";

export default function PostPurchasePage(props: RouteComponentProps<any>) {
  const wfStatus = [TradeStatusEnum.Aprovado, TradeStatusEnum.Pendencia];
  const wfPhases = [TradePhaseEnum.Payment];
  const cardTitle = "Operações Finalizadas";

  return <WorkflowTradeList listStatus={wfStatus} listPhase={wfPhases} cardTitle={cardTitle} showArchivedTrades={false} />;
}



// WEBPACK FOOTER //
// ./src/pages/monitor/post-pruchase/PostPurchase.page.tsx